import { Card, ExerciseThumbnail } from "../../design-v2";
import { resolveCardioModality } from "../../utils/cardioModality";
import { formatProductLabel } from "./presentationFormatters";

function formatHeartRate(prescription) {
  if (prescription.heartRateTargetMode === "avg_bpm") {
    return prescription.heartRateTargetValue != null
      ? `${prescription.heartRateTargetValue} bpm`
      : null;
  }
  if (prescription.heartRateTargetMode === "zone") {
    return prescription.heartRateTargetValue != null
      ? `Zone ${prescription.heartRateTargetValue}`
      : null;
  }
  return null;
}

export default function CardioCard({ block, position }) {
  const prescription = block.cardioPrescription || {};
  const settings = Array.isArray(prescription.machineSettings)
    ? prescription.machineSettings
    : [];
  const name = block.exercise || "Cardio";
  const resolvedModality = resolveCardioModality(block.exerciseId, prescription.modality);
  const modalityLabel = resolvedModality ? formatProductLabel(resolvedModality) : null;
  const shouldShowModality = Boolean(
    modalityLabel && modalityLabel.toLowerCase() !== name.toLowerCase()
  );
  const heartRate = formatHeartRate(prescription);
  const notes = prescription.notes || block.notes;

  return (
    <Card
      as="article"
      padding="none"
      className="lz-product-cardio-card"
      aria-label={name}
      data-layout="thumbnail-first"
    >
      <header className="lz-product-cardio-card__header">
        {position ? <span className="lz-product-block-index lz-product-block-index--info">{position}</span> : null}
        <span className="lz-product-exercise-card__media" data-testid="exercise-media">
          <ExerciseThumbnail exerciseId={block.exerciseId} src={null} size={80} alt="" />
        </span>
        <div className="lz-product-cardio-card__heading-copy">
          <span className="lz-product-cardio-card__eyebrow">Cardio</span>
          <h3>{name}</h3>
        </div>
      </header>
      <dl className="lz-product-cardio-card__stats">
        {shouldShowModality ? (
          <div>
            <dt>Modality</dt>
            <dd>{modalityLabel}</dd>
          </div>
        ) : null}
        {prescription.durationMinutes != null ? (
          <div>
            <dt>Duration</dt>
            <dd>{prescription.durationMinutes} min</dd>
          </div>
        ) : null}
        {heartRate ? (
          <div>
            <dt>Heart rate</dt>
            <dd>{heartRate}</dd>
          </div>
        ) : null}
      </dl>
      {settings.length > 0 ? (
        <div className="lz-product-cardio-card__settings" aria-label="Machine settings">
          {settings.map((setting) => (
            <span key={setting.key}>
              {formatProductLabel(setting.key)}: {setting.value}
            </span>
          ))}
        </div>
      ) : null}
      {notes ? <p className="lz-product-block-notes">{notes}</p> : null}
    </Card>
  );
}
